"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitAnalytics = void 0;
var _analytics = require("../../../../analytics");
var _types = require("../../../../types");
/** События аналитики для инпута ввода номера квартиры */
const submitAnalytics = _ref => {
  let {
    flatNumber,
    area,
    roomsCount
  } = _ref;
  if (area) {
    // Запрос по номеру квартиры вернул результат
    (0, _analytics.trackMyHomeFlatNumberPick)({
      value: flatNumber,
      auto: true
    });

    // Площадь была заполнена из саджеста
    (0, _analytics.getTrackMyHomeAreaPick)({
      estimationTarget: _types.EEstimationTargets.flat,
      value: area,
      auto: true
    })();
    if (roomsCount) {
      // Комнатность была заполнена из саджеста
      (0, _analytics.trackMyHomeRoomsCountClick)({
        value: roomsCount,
        auto: true
      });
    }
  } else {
    // Запрос по номеру квартиры не вернул ничего
    (0, _analytics.trackMyHomeFlatNumberPick)({
      value: flatNumber,
      auto: false
    });
  }
};
exports.submitAnalytics = submitAnalytics;